import React from 'react';
import {connect} from 'react-redux';

class Experience extends React.Component{
    render(){
       // console.log(this.props.expList);
        if (typeof this.props.expList !== "undefined" && this.props.expList.length>0 ){
            //Sort it by id
            // this.props.expList.sort((a,b)=>{
            //     return a.id.localeCompare(b.id);
            // });
            this.props.expList.sort((a, b) => { return a.id - b.id; });


            var exp = this.props.expList.map((exp)=>{
                let summaryBullets;

                if (typeof exp.descBullets !== "undefined"
                    &&  exp.descBullets.length > 0){
                    summaryBullets = exp.descBullets.map((descBullet, index) => {
                            return <li key={index}>{descBullet}</li>
                        })
                    }
                return <div key={exp.id} className="c-timeline__item">
                    <div className="c-timeline__point  t-timeline__point  t-primary-bg"></div>
                    <div className="o-content">
                        <div className="o-grid">
                            <div className="o-grid__col-md-5">
                                <div className="c-work__timeframe">
                                    {exp.fromDate} &ndash; {exp.toDate}
                                                </div>
                                <h3 className="c-work__heading">
                                    {exp.companyName}
                                                </h3>
                                <h4 className="c-work__title">
                                    {exp.jobRole}
                                                </h4>
                                <div className="c-work__location">
                                    {exp.location}
                                                </div>
                            </div>
                            <div>
                                <p>
                                    {exp.description}
                                    {summaryBullets}
                                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            })
        }
        return(

            <section className="o-section  t-section  ">

                <div className="o-section__header-bg  t-section__header"></div>
                <div className="o-section__content-bg  t-section__content"></div>

                <div className="o-container">
                    <div className="o-section__container">

                        <header className="o-section__header  t-section__header">
                            <div className="o-content">
                                <h2 className="o-section__heading">
                                    Experience
                                </h2>
                                <div className="o-content__body  o-section__description">
                                   
                                </div>
                            </div>
                        </header>

                        <div className="o-section__content  t-section__content  u-pb-0">

                            <div className="a-experience-timeline  c-timeline  t-border-color">
                         
                                {exp}
  
                            </div>

                        </div>

                    </div>
                </div>

            </section> 


        );
    }
}

const mapStateToProps = (state)=>{
    return{
        expList: state.experience.experienceList
    }
}
export default connect(mapStateToProps)(Experience);


// WEBPACK FOOTER //
// ./src/components/Experience.js